import React, { Suspense } from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import { ErrorBoundary } from 'core';
import { times } from 'lodash';

import { QueryListChatActivityAssignees, QueryListChatActivityAssigneesProps } from 'deprecated/queries';

import { ContentLoaderListItem, LegendListNodes, Popper, PopperProps } from 'components/v2';

const styles = () =>
  createStyles({
    root: {
      width: '486px !important',
    },
    infiniteScrollWrapper: {
      overflow: 'auto',
      flex: 1,
    },
  });

export interface PopperChatActivityAssigneesProps
  extends Omit<PopperProps, 'classes' | 'children'>,
    WithStyles<typeof styles> {
  query?: string;
  onNodeSelected?: QueryListChatActivityAssigneesProps['onNodeSelected'];
}

const PopperChatActivityAssignees: React.FC<PopperChatActivityAssigneesProps> = ({
  classes,
  query = '',
  onNodeSelected,
  ...rest
}) => (
  <Popper className={classes.root} {...rest}>
    <LegendListNodes query={query} />
    <div className={classes.infiniteScrollWrapper}>
      <ErrorBoundary>
        <Suspense
          fallback={times(15, (i) => (
            <ContentLoaderListItem width={486} includeAvatar key={i} />
          ))}
        >
          <QueryListChatActivityAssignees
            variables={{
              regex: query && `(?i)${query}`,
              includeAvatar: true,
              includeEmail: true,
            }}
            disablePadding
            onNodeSelected={onNodeSelected}
          />
        </Suspense>
      </ErrorBoundary>
    </div>
  </Popper>
);

export default withStyles(styles)(PopperChatActivityAssignees);
